'use client';

/**
 * Australian Binary Plan - Custom Layout
 * All components are specific to this plan only, kept in this folder.
 */

import { PlanIntroSection } from '../common/plan-intro-section';
import { FeaturesSection } from '../common/features-section';
import { WhySoftwareSection } from '../common/why-software-section';
import { PlanOverviewSection } from './PlanOverviewSection';
import { WhatIsPlanSection } from './WhatIsPlanSection';
import { HowItWorksSection } from './HowItWorksSection';

interface MLMPlan {
  slug: string;
  name: string;
  description: string;
  content: string;
  image?: string;
  features?: string[];
}

interface PlanDetailContentProps {
  plan: MLMPlan;
}

export default function PlanDetailContent({ plan }: PlanDetailContentProps) {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-950">
      <PlanIntroSection
        plan={plan}
        translationNamespace="planDetails.australianBinaryPlan.hero"
        imageSrc="/images/mlm-plans/australianbinary_animate.gif"
        descriptionKeys={['description1', 'description2']}
      />
      <PlanOverviewSection plan={plan} />
      <WhatIsPlanSection plan={plan} imageSrc="/images/mlm-plans/australianbinary_animate.gif" />
      <HowItWorksSection plan={plan} />
      <FeaturesSection plan={plan} translationNamespace="planDetails.australianBinaryPlan.features" />
      <WhySoftwareSection plan={plan} translationNamespace="planDetails.australianBinaryPlan.whySoftware" />
    </div>
  );
}

